import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Resource } from "@/types/resource";
import { Phone, MapPin, Clock, Tag } from "lucide-react";

interface ResourceCardProps {
  resource: Resource;
}

const ResourceCard = ({ resource }: ResourceCardProps) => {
  const availabilityColor = {
    available: "bg-green-100 text-green-800",
    limited: "bg-yellow-100 text-yellow-800",
    unavailable: "bg-red-100 text-red-800",
  }[resource.availability];

  // Detailed logging to debug the tag issue
  console.log('Resource being rendered:', resource);
  console.log('Resource tags:', resource.tags);
  if (resource.tags) {
    console.log('Number of tags:', resource.tags.length);
    resource.tags.forEach((tag, index) => {
      console.log(`Tag ${index}:`, tag);
    });
  }

  // Ensure we have a valid tags array
  const validTags = Array.isArray(resource.tags) ? resource.tags : [];

  return (
    <Card className="w-full hover:shadow-lg transition-shadow">
      <CardHeader>
        <div className="flex justify-between items-start">
          <CardTitle className="text-xl font-semibold">{resource.name}</CardTitle>
          <Badge variant="outline" className={availabilityColor}>
            {resource.availability}
          </Badge>
        </div>
        <Badge variant="secondary">{resource.type}</Badge>
      </CardHeader>
      <CardContent>
        <CardDescription className="mb-4">{resource.description}</CardDescription>
        <div className="space-y-2 text-sm">
          {resource.area_description ? (
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4" />
              <span>{resource.area_description}</span>
            </div>
          ) : resource.address ? (
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4" />
              <span>{resource.address}</span>
            </div>
          ) : null}
          {resource.phone && (
            <div className="flex items-center gap-2">
              <Phone className="w-4 h-4" />
              <span>{resource.phone}</span>
            </div>
          )}
          {resource.operating_hours && (
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4" />
              <span>Hours: {resource.operating_hours}</span>
            </div>
          )}
          {validTags.length > 0 && (
            <div className="flex items-center gap-2">
              <Tag className="w-4 h-4" />
              <div className="flex flex-wrap gap-1">
                {validTags.map((tag) => (
                  <Badge key={tag.name} variant="outline" className="text-xs">
                    {tag.name}
                  </Badge>
                ))}
              </div>
            </div>
          )}
          <div className="flex items-center gap-2 text-muted-foreground">
            <Clock className="w-4 h-4" />
            <span>Updated {new Date(resource.last_updated).toLocaleDateString()}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ResourceCard;